<template>
    <div class="row">
        <div class="col-3">
            <button
                type="button"
                class="btn btn-primary btn-block mb-2"
                @click="createScene()"
                :disabled="loading || exporting"
            >
                New document (blank)
            </button>

            <button
                type="button"
                class="btn btn-primary btn-block mb-2"
                @click="createScene(true)"
                :disabled="loading || exporting"
            >
                New document from image
            </button>

            <span v-if="!loading">
                <button
                    :key="'load-button'"
                    type="button"
                    class="btn btn-primary btn-block mb-2"
                    @click="loadScene()"
                    :disabled="exporting"
                >
                    Open existing document
                </button>
            </span>
            <span v-else>
                <button :key="'loading-button'" type="button" class="btn btn-primary btn-block mb-2">
                    <i class="fal fa-spinner-third fa-spin mr-1"></i>
                    <span style="opacity: 0.5">Open existing document</span>
                </button>
            </span>

            <hr>

            <form v-on:submit.prevent="replaceTexts()">
                <input v-model="text" type="text" class="form-control mb-2" placeholder="Enter replacement text here">
                <button type="submit" class="btn btn-primary btn-block mb-2" :disabled="loading || exporting">
                    Replace text in all placeholders
                </button>
            </form>

            <hr>

            <span v-if="exporting !== 'png'">
                <button
                    :key="'export-png-button'"
                    type="button"
                    class="btn btn-primary btn-block mb-2"
                    @click="exportScene('png')"
                    :disabled="loading || exporting"
                >
                    Download preview image
                </button>
            </span>
            <span v-else>
                <button :key="'exporting-png-button'" type="button" class="btn btn-primary btn-block mb-2">
                    <i class="fal fa-spinner-third fa-spin mr-1"></i>
                    <span style="opacity: 0.5">Download preview image</span>
                </button>
            </span>

            <span v-if="exporting !== 'pdf'">
                <button
                    :key="'export-pdf-button'"
                    type="button"
                    class="btn btn-primary btn-block mb-2"
                    @click="exportScene('pdf')"
                    :disabled="loading || exporting"
                >
                    Download PDF preview
                </button>
            </span>
            <span v-else>
                <button :key="'exporting-pdf-button'" type="button" class="btn btn-primary btn-block mb-2">
                    <i class="fal fa-spinner-third fa-spin mr-1"></i>
                    <span style="opacity: 0.5">Download PDF preview</span>
                </button>
            </span>

            <hr>

            <span v-if="exporting !== 'archive'">
                <button
                    :key="'export-archive-button'"
                    type="button"
                    class="btn btn-primary btn-block mb-2"
                    @click="saveToArchive()"
                    :disabled="loading || exporting"
                >
                    Save to IMG.LY archive
                </button>
            </span>
            <span v-else>
                <button :key="'exporting-archive-button'" type="button" class="btn btn-primary btn-block mb-2">
                    <i class="fal fa-spinner-third fa-spin mr-1"></i>
                    <span style="opacity: 0.5">Save to IMG.LY archive</span>
                </button>
            </span>
        </div>
        <div class="col">
            <div id="cesdk-demo-ce-container" style="height: calc(100vh - 180px); width: 100%"></div>
        </div>
    </div>
</template>

<script>
    import CreativeEditorSDK from '@cesdk/cesdk-js';
    export default {
        components: { CreativeEditorSDK },
        data () {
            return {
                cesdk: null,
                scene: null,
                loading: false,
                text: '',
                exporting: null
            }
        },
        async mounted () {
            $('body').removeClass('login-body');

            // Maximise page area.
            $('.header-bar').hide();
            this.$parent.hideMaintenanceNotice();
            $('body').addClass('img-ly-demo');
            
            const cesdkConfig = {
                license: this.$root.app.img_ly_license_key,
                baseURL: 'https://cdn.img.ly/packages/imgly/cesdk-js/1.66.1/assets',
                callbacks: {
                    onUpload: 'local'
                }
            }

            this.cesdk = await CreativeEditorSDK.create('#cesdk-demo-ce-container', cesdkConfig);
            await this.cesdk.addDefaultAssetSources();
            await this.cesdk.addDemoAssetSources({ sceneMode: 'Design' });

            await this.cesdk.ui.registerComponent('insert-variable', ({ builder/*, state*/ }) => {
                //const { value, setValue } = state('counter', 0);

                builder.Button('insert-variable-button', {
                    label: `+ Variable`,
                    onClick: () => {
                        /*const pressed = value + 1;
                        setValue(pressed);*/
                        const selectedBlocks = this.cesdk.engine.block.findAllSelected();
                        if (!selectedBlocks || (selectedBlocks.length == 0)) {
                            console.log('Please select the text to create a variable from');
                            return;
                        }
                        const selectedRange = this.cesdk.engine.block.getTextCursorRange();
                        if (selectedRange.from == selectedRange.to) {
                            console.log('Please select the text to create a variable from');
                            return;
                        }

                        let text = this.cesdk.engine.block.getString(selectedBlocks[0], 'text/text');
                        text = text.replace(/{{(.*?)}}/g, '^');
                        const selectedText = text.substring(selectedRange.from, selectedRange.to);
                        if (selectedText.indexOf('^') > -1) {
                            console.log('A variable cannot contain another variable. Please select a different text range or remove the existing variable markers.');
                            return;
                        }
                        if (selectedText.indexOf('{{') > -1) {
                            console.log('A variable cannot contain another variable. Please select a different text range or remove the existing {{ variable markers.');
                            return;
                        }
                        if (selectedText.indexOf('}}') > -1) {
                            console.log('A variable cannot contain another variable. Please select a different text range or remove the existing }} variable markers.');
                            return;
                        }

                        this.cesdk.engine.block.replaceText(
                            selectedBlocks[0],
                            '}}',
                            selectedRange.to
                        );
                        this.cesdk.engine.block.replaceText(
                            selectedBlocks[0],
                            '{{',
                            selectedRange.from
                        );
                    }
                });
            });

            await this.cesdk.ui.insertCanvasMenuOrderComponent(
                'ly.img.text.italic.canvasMenu',
                'insert-variable',
                'after',
                { editMode: 'Text' }
            );
            await this.cesdk.ui.insertCanvasMenuOrderComponent(
                'ly.img.text.italic.canvasMenu',
                'ly.img.separator',
                'after',
                { editMode: 'Text' }
            );

            this.cesdk.ui.removeCanvasMenuOrderComponent('ly.img.text.color.canvasMenu', { editMode: 'Text' });
            //this.cesdk.ui.removeCanvasMenuOrderComponent('ly.img.text.bold.canvasMenu', { editMode: 'Text' });
            //this.cesdk.ui.removeCanvasMenuOrderComponent('ly.img.text.italic.canvasMenu', { editMode: 'Text' });

            this.createScene();
        },
        beforeUnmount() {
            if (this.cesdk) {
                this.cesdk.dispose();
                this.cesdk = null;
            }
        },
        watch: {
            //
        },
        methods: {
            createScene: function (fromImage = false) {
                var vm = this;
                if (fromImage) {
                    this.cesdk.createFromImage(
                        'https://img.ly/static/ubq_samples/sample_4.jpg'
                    )
                    .then(response => {
                        console.log('Created from image. Scene ID:', response);
                        vm.scene = response;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

                    return null;
                }
                this.cesdk.createDesignScene()
                .then(response => {
                    console.log('Created blank document. Scene ID:', response);
                    vm.scene = response;
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            loadScene: function () {
                this.loading = true;
                var vm = this;
                this.cesdk.engine.scene.loadFromArchiveURL(
                    this.$root.app.app_url + '/img-ly-demo/archive.zip'
                )
                .then(response => {
                    console.log('Loaded existing document. Scene ID:', response);
                    vm.scene = response;
                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(() =>
                    vm.loading = false
                );
            },
            exportScene: function (type) {
                this.exporting = type;
                var vm = this;
                const options = (type == 'png')
                    ? {
                        mimeType: 'image/png',
                        pngCompressionLevel: 7
                    }
                    : {
                        mimeType: 'application/pdf',
                        exportPdfWithUnderlayer: true,
                        underlayerSpotColorName: 'RDG_WHITE',
                        underlayerOffset: -2.0
                    }
                this.cesdk.engine.block.export(
                    this.scene,
                    options
                )
                .then(response => {
                    console.log('Exported', type, response);

                    const element = document.createElement('a');
                    element.setAttribute('href', window.URL.createObjectURL(response));
                    element.setAttribute('download', 'preview.' + type);
                    element.style.display = 'none';
                    element.click();
                    element.remove();
                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(() =>
                    setTimeout(function () { vm.exporting = null; }, 1000)
                );
            },
            saveToArchive: function () {
                this.exporting = 'archive';
                var vm = this;
                this.cesdk.engine.scene.saveToArchive()
                .then(response => {
                    console.log('Saved archive', response);

                    const element = document.createElement('a');
                    element.setAttribute('href', window.URL.createObjectURL(response));
                    element.setAttribute('download', 'archive.zip');
                    element.style.display = 'none';
                    element.click();
                    element.remove();
                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(() =>
                    setTimeout(function () { vm.exporting = null; }, 1000)
                );
            },
            replaceTexts: function () {
                const placeholders = this.cesdk.engine.block.findAllPlaceholders();
                console.log(placeholders);
                
                placeholders.forEach((item) => {
                    this.cesdk.engine.block.replaceText(item, this.text);
                });
            }
        }
    }
</script>
